/* eslint-disable react/display-name */
import { forwardRef } from 'react';
import {
  GridToolbarDensitySelector as MuiGridToolbarDensitySelector,
  GridToolbarFilterButton as MuiGridToolbarFilterButton,
  GridToolbarColumnsButton as MuiGridToolbarColumnsButton,
  GridToolbarContainer as MuiGridToolbarContainer,
  GridToolbarContainerProps,
  GridToolbarExport as MuiGridToolbarExport,
  GridToolbarExportProps,
  useGridRootProps,
} from '@mui/x-data-grid-pro';

export const ControllerGridToolbarColumnsButton = () => (
  <MuiGridToolbarColumnsButton
    size='medium'
    color='secondary'
    // below props are a workaround to avoid typescript error
    onResize={undefined}
    onResizeCapture={undefined}
  />
);
export const ControllerGridToolbarDensitySelector = () => (
  <MuiGridToolbarDensitySelector
    size='medium'
    color='secondary'
    // below props are a workaround to avoid typescript error
    onResize={undefined}
    onResizeCapture={undefined}
  />
);
export const ControllerGridToolbarFilterButton = () => (
  <MuiGridToolbarFilterButton
    componentsProps={{ button: { size: 'medium', color: 'inherit' } }}
    // below props are a workaround to avoid typescript error
    onResize={undefined}
    onResizeCapture={undefined}
  />
);
export const ControllerGridToolbarExport = (props: GridToolbarExportProps) => (
  <MuiGridToolbarExport size='medium' color='secondary' {...props} />
);

interface GridToolbarProps
  extends GridToolbarContainerProps,
    Pick<GridToolbarExportProps, 'csvOptions' | 'printOptions'> {}

export const ControllerGridToolbar = forwardRef<HTMLDivElement, GridToolbarProps>(
  function ControllerGridToolbar({ className, csvOptions, printOptions, ...other }: GridToolbarProps, ref) {
    const rootProps = useGridRootProps();

    if (
      rootProps.disableColumnFilter &&
      rootProps.disableColumnSelector &&
      rootProps.disableDensitySelector
    ) {
      return null;
    }

    return (
      <MuiGridToolbarContainer ref={ref} {...other}>
        <ControllerGridToolbarColumnsButton />
        <ControllerGridToolbarFilterButton />
        <ControllerGridToolbarDensitySelector />
        <ControllerGridToolbarExport csvOptions={csvOptions} printOptions={printOptions} />
      </MuiGridToolbarContainer>
    );
  }
);
